import React, { useState, useEffect } from "react";
import { playClickSound } from "../../utils/soundUtils.js";
import {
  hasSeenWelcome,
  markWelcomeAsSeen,
  saveToStorage,
} from "../../utils/localStorage.js";
import WelcomeDialog from "../WelcomeDialog.js";
import QuoteCarousel from "../QuoteCarousel.js";
import DecryptText from "../DecryptText.js";

function StreetsMenu({
  character,
  onNavigate,
  onShowInventory,
  onToggleMobileStats,
  showMobileStats,
}) {
  const [showWelcome, setShowWelcome] = useState(false);

  // Check if this is the first visit to streets
  useEffect(() => {
    if (!hasSeenWelcome()) {
      setShowWelcome(true);
    }
  }, []);

  const handleCloseWelcome = () => {
    setShowWelcome(false);
    markWelcomeAsSeen();
  };

  const handleResetStories = () => {
    saveToStorage("completedStories", []);
    playClickSound();
  };

  const location = {
    name: "Burning Chrome",
    description:
      "The neon-lit streets pulse with digital life. Data streams flow through the air like electronic rain, carrying secrets and lies in equal measure.",
    quotes: [
      "The sky above the port was the color of television, tuned to a dead channel.",
      "The street finds its own uses for things.",
      "The future is already here — it's just not evenly distributed.",
      "Time moves in one direction, memory in another.",
    ],
    options: [
      { key: "chiba-city", label: "Chiba City" },
      { key: "inventory", label: "Inventory" },
      { key: "help", label: "Help" },
      { key: "reset-stories", label: "Reset Stories", isSpecial: true },
    ],
  };

  return (
    <>
      {showWelcome && <WelcomeDialog onClose={handleCloseWelcome} />}

      <div className="location-screen">
        <div className="location-header">
          <h2>{location.name}</h2>
        </div>

        <div className="location-description">
          <DecryptText
            text={location.description}
            duration={1000}
            mode="random"
            className="decrypt-description"
          />
        </div>

        <QuoteCarousel quotes={location.quotes || []} />

        <div className="options-grid">
          {location.options.map((option) => (
            <div key={option.key} className="option-row">
              <button
                className={
                  option.isSpecial ? "menu-button reset-button" : "menu-button"
                }
                onClick={() => {
                  if (option.key === "reset-stories") {
                    handleResetStories();
                  } else {
                    playClickSound();
                    onNavigate(option.key);
                  }
                }}
              >
                {option.label}
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default StreetsMenu;
